<template>
  <div>
    <transition name="fade">
      <div
        v-if="visible"
        class="mask"
        :style="{ backgroundColor: bgColor }"
        @click.stop="clickHandle"
      ></div>
    </transition>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Popup',
  props: {
    bgColor: {
      type: String,
      default: 'rgba(0,0,0,.5)'
    },
    maskClick: {
      type: Boolean,
      default: false
    },
    visible: {
      default: false,
      type: Boolean,
    }
  },
  methods: {
    clickHandle() {
      this.maskClick && this.$emit('onMaskClick');
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.content {
  position: relative;
  height: 100vh;
  z-index: 1000;
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.55);
}
</style>
